import { formats } from '@comall-backend-builder/types';

/**
 * 富文本格式化：提交时保留仅含图片/视频等非文字内容
 */
export class StringRichTextPZGFormat extends formats.StringFormat {
    formatParams(key: string, value: any) {
        if (typeof value === 'string') {
            return { [key]: value };
        }
        return { [key]: value ?? '' };
    }
}
